// @module Room4.CCACategoryDescriptionFooter.CategoryDescriptionFooter
define("Room4.CCACategoryDescriptionFooter.CategoryDescriptionFooter.View", [
  "room4_ccacategorydescriptionfooter_categorydescriptionfooter.tpl",
  "Room4.CCACategoryDescriptionFooter.SS2Model",
  "Backbone",
  "Categories",
], function (
  room4_ccacategorydescriptionfooter_categorydescriptionfooter_tpl,
  CCACategoryDescriptionFooterSS2Model,
  Backbone,
  Categories
) {
  "use strict";

  // @class Room4.CCACategoryDescriptionFooter.CategoryDescriptionFooter.View @extends Backbone.View
  return Backbone.View.extend({
    template: room4_ccacategorydescriptionfooter_categorydescriptionfooter_tpl,

    render: function render() {
      var res = Backbone.View.prototype.render.apply(this, arguments);
      var self = this;
      // Defer to allow SCA to insert into DOM if part of composite view
      setTimeout(function () {
        self.afterViewRender && self.afterViewRender();
      }, 0);
      return res;
    },

    initialize: function initialize(options) {
      this.container = options.container;
      this.model = new CCACategoryDescriptionFooterSS2Model();
      var categoryUrl = this.getCurrentCategoryUrl();
      var self = this;
      this.model
        .fetch({
          data: {
            fullurl: categoryUrl,
          },
        })
        .done(function (result) {
          self.description = result.data.description;
          if (result.error) {
            console.error("Error fetching category description:", result.error);
          }
          self.render();
        });
    },

    events: {},

    bindings: {},

    childViews: {},

    // Override Backbone.View.render to hook after the template is in DOM through layout
    // In SCA, afterAppendToDom is usually available; fallback to a small timeout
    afterViewRender: function afterViewRender() {},

    getParentView: function getParentView() {
      return this.container
        .getLayout()
        .getApplication()
        .getLayout()
        .getCurrentView();
    },

    getCurrentCategoryUrl: function getCurrentCategoryUrl() {
      var parentView = this.getParentView();
      var category = parentView.model.get("category");
      return category === null || category === void 0
        ? void 0
        : category.get("fullurl");
    },

    //@method getContext @return Room4.CCACategoryDescriptionFooter.CategoryDescriptionFooter.View.Context
    getContext: function getContext() {
      var parentView = this.getParentView();
      // parentView.translator.categoryUrl contains the current category URL

      var description = this.description || "";
      if (!description) {
        var _category$get;
        var category = parentView.model.get("category");
        description =
          (_category$get =
            category === null || category === void 0
              ? void 0
              : category.get("description")) !== null &&
          _category$get !== void 0
            ? _category$get
            : "";
      }

      // Determine if there is any meaningful content (strip HTML for emptiness check)
      var hasContent =
        (description || "").replace(/<[^>]*>/g, "").trim().length > 0;
      return {
        showDescription: hasContent,
        description: description,
      };
    },
  });
});
